import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function TaskCardSkeleton() {
  return (
    <Card className="overflow-hidden">
      <div className="flex flex-col sm:flex-row">
        {/* Thumbnail Skeleton */}
        <Skeleton className="w-full sm:w-48 h-48 rounded-none" />

        {/* Content Skeleton */}
        <div className="flex-1 p-4 flex flex-col">
          <div className="flex items-start justify-between gap-4 mb-3">
            <div className="flex-1">
              <Skeleton className="h-6 w-3/4 mb-2" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-2/3 mt-1" />
            </div>
            <Skeleton className="h-7 w-24 rounded-full" />
          </div>

          <div className="flex items-center gap-4 mb-4">
            <Skeleton className="h-3 w-32" />
            <Skeleton className="h-3 w-32" />
          </div>

          {/* Actions Skeleton */}
          <div className="mt-auto flex items-center gap-2">
            <Skeleton className="h-9 w-28" />
            <Skeleton className="h-9 w-20" />
            <Skeleton className="h-9 w-24" />
          </div>
        </div>
      </div>
    </Card>
  );
}

export function TaskListSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <TaskCardSkeleton key={i} />
      ))}
    </div>
  );
}
